import { Typography } from "antd";

import promptMessageDisplay from "../../assets/promptStudioOnboarding/LeftBanner.png";
import WelcomePrompt from "../../assets/promptStudioOnboarding/WelcomePrompt.svg";
import PromptCoverage from "../../assets/promptStudioOnboarding/PromptCoverage.svg";
import PerPromptLLMProfiles from "../../assets/promptStudioOnboarding/PromptLLM.svg";
import SaveCosts from "../../assets/promptStudioOnboarding/SaveCosts.svg";

const { Paragraph } = Typography;

export const PromptSlides = [
  {
    imageIcon: WelcomePrompt,
    image: promptMessageDisplay,
    title: "Welcome to the best prompt engineering environment!",
    text: (
      <Paragraph>
        Struggling with prompts in your regular IDE? Prompt Studio is built from
        the ground up for seamless prompt engineering. For all your prompts, you
        can check outputs from multiple LLMs, you always have a side-by-side
        view of the extracted values and sample source documents. We’ve even
        included an example project for you to easily get started with.
      </Paragraph>
    ),
  },
  {
    imageIcon: PromptCoverage,
    image: promptMessageDisplay,
    title: "Prompt Coverage",
    text: (
      <Paragraph>
        For practical document extraction, you need generic prompts that work
        across any form of the document type you’re dealing with. With the
        Prompt Coverage feature, you can see how well prompts are performing for
        the sample document set in your projects.
      </Paragraph>
    ),
  },
  {
    imageIcon: PerPromptLLMProfiles,
    image: promptMessageDisplay,
    title: "Per-prompt LLM Profiles",
    text: (
      <Paragraph>
        You can configure cheaper and faster LLMs for prompts that extract
        simple information while reserving more powerful, but expensive LLMs for
        complex extractions. When such projects are deployed as APIs or ETL
        pipelines, multiple LLMs are seamlessly used to extract the
        corresponding fields for the same document type.
      </Paragraph>
    ),
  },
  {
    imageIcon: SaveCosts,
    image: promptMessageDisplay,
    title: "Save costs up to 6x",
    text: (
      <Paragraph>
        When processing a large number of documents, prompts, input and output
        sizes begin to matter. You can save costs up to 6x by simply turning on
        Single-Pass Extraction and Summarized Extraction and we’ll do all the
        heavy-lifting for you!
      </Paragraph>
    ),
  },
];
